import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-ver-adjunto',
  templateUrl: './ver-adjunto.component.html',
  styleUrls: ['./ver-adjunto.component.scss'],
  animations:fuseAnimations
})
export class VerAdjuntoComponent implements OnInit {

  layout = JSON.parse(localStorage.getItem('config')).layout
  scheme = JSON.parse(localStorage.getItem('config')).scheme

  src: any;
  modal: MatDialog;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<VerAdjuntoComponent>
    ) { 
      this.data = data
      this.modal= data.ref
    }

  ngOnInit(): void {
    this.src = environment.urlUpload+(this.data.adjunto);
  }


  closeMenu(){
    this.dialogRef.close()
  }



}
